import Image from 'next/image'
import cn from 'classnames'

import s from './FetchPetInsurance.module.scss'

export const FetchPetInsurance = () => {
  return (
    <section className={s.fetchSection}>
      <div className={s.fetchContentLight}>
        <div className={s.sectionContent}>
          <div className={s.introText}>
            <p>
              Mawoo Pets has partnered with Fetch Pet Insurance to ensure our
              puppies have access to the most comprehensive coverage for the
              rest of their lives. Our partnership gives Mawoo Pets families
              access to the following benefits:
            </p>
            <ul>
              <li>Access to the most comprehensive coverage for your pet</li>
              <li>10% LIFETIME discount on your pet’s policy</li>
              <li>
                Waived waiting periods, meaning your pet won’t have to wait to
                be covered
              </li>
              <li>$25 gift card to Fetch Rx</li>
              <li> A Free Fetch Health Forecast Report</li>
              <li>Concierge Service and Expedited Claims Reimbursement</li>
            </ul>

            <p>
              Receive a custom quote for your new puppy, and access these unique
              benefits through Mawoo Pets
            </p>
          </div>

          <div className={s.header}>
            <Image
              src="/insurance/dog-header-image.png"
              alt="Fetch Pet Insurance Logo"
              width={1220 / 2}
              height={804 / 2}
              className={s.sectionImage}
            />

            <Image
              src="/insurance/fetch-logo.png"
              alt="Fetch Pet Insurance Logo"
              width={250}
              height={100}
              className={s.fetchLogo}
            />
          </div>
        </div>
      </div>

      <div className={s.fetchContentDark}>
        <div className={cn(s.sectionContent, s.sectionContentSpace)}>
          <div className={s.faqItem}>
            <Image
              src="/insurance/what-covers.png"
              alt="Fetch Pet Insurance Logo"
              width={2120 / 2}
              height={1524 / 2}
              className={s.sectionImage}
            />
          </div>
        </div>
      </div>

      <div className={s.fetchContentLight}>
        <div className={cn(s.sectionContent, s.sectionContentSpace)}>
          <div className={s.faqItem}>
            <Image
              src="/insurance/coverage.png"
              alt="Fetch Pet coverage details"
              width={2120 / 2}
              height={1524 / 2}
              className={s.sectionImage}
            />
          </div>
        </div>
      </div>

      <div className={s.fetchContentDark}>
        <div className={s.sectionContent}>
          <h3>Do I need Pet Insurance for my puppy?</h3>
          <div className={s.faqItem}>
            <Image
              src="/insurance/common-issues.png"
              alt="Fetch Pet common issues"
              width={2300 / 2}
              height={1102 / 2}
              className={s.sectionImage}
            />
          </div>
        </div>
      </div>

      <div className={cn(s.sectionContent, s.sectionContentSpace)}>
        <p className={s.legal}>
          Most comprehensive and most extensive coverage according to Consumers
          Advocate, January 2023. Based on a comparison of injury and illness
          coverage between Fetch and North American pet insurance providers on
          <a
            href="https://consumersadvocate.org."
            target="_blank"
            rel="noreferrer"
          >
            consumersadvocate.org.
          </a>
          This information is descriptive only. Policy activation periods, risk
          free cancellation terms, waiting periods, limitations, exclusions to
          coverage and other terms and conditions vary by state or province and
          are subject to change without notice. Please see your policy for full
          terms and conditions of coverage. If there is any conflict between the
          policy and this product information, the provisions of the policy
          shall prevail. Fetch insurance policies are administered by Fetch
          Insurance Services, LLC (d/b/a Fetch Pet Insurance, Fetch Pet
          Insurance Services in New York and British Columbia, Fetch Insurance
          in Nebraska, Fetch Pet Insurance Services, LLC in Michigan, North
          Dakota, New Mexico and California) CA license # 0F60627 and
          underwritten by AXIS Insurance Company, an Illinois Corporation, in
          the U.S. and AXIS Reinsurance Company (Canadian Branch) in Canada. For
          more information, visit
          <a href="https://fetchpet.com" target="_blank" rel="noreferrer">
            fetchpet.com
          </a>
          . 2025 Fetch, Inc.
        </p>
      </div>
    </section>
  )
}
